import type { Course } from "../../backend/api/learning";
import { useSignOut } from "../../backend/queries/auth";
import { Page, PageHeader, PageSection } from "../../components/patterns";
import { Button } from "../../components/ui/button";
import { CoursePanel } from "./CoursePanel";

export function RequiredOnboarding({ courses }: { courses: Course[] }) {
  const signOut = useSignOut();
  return (
    <Page width="content">
      <PageHeader
        title="Your onboarding"
        description="Complete your required onboarding before continuing to the portal."
        actions={
          <Button
            variant="outline"
            onClick={() => signOut.mutate()}
            disabled={signOut.isPending}
          >
            Sign out
          </Button>
        }
      />
      <PageSection
        title={`${courses.length} required ${courses.length === 1 ? "course" : "courses"} remaining`}
        description="Complete each course below. The portal opens automatically when all required courses are done."
      >
        <div className="grid gap-6">
          {courses.map((course) => (
            <CoursePanel key={course.id} course={course} admin={false} />
          ))}
        </div>
      </PageSection>
    </Page>
  );
}
